<template>
  <v-flex class="client-details">
    <v-card id="clientDetails">
      <v-card-title class="card-title">
        Details
      </v-card-title>
      <v-divider />
      <v-card-text class="details-container">
        <div>
          <span>Email:</span>
          <span>Phone:</span>
        </div>
        <div>
          <span>{{ profile.email }}</span>
          <span>{{ profile.phone }}</span>
        </div>
        <div v-if="!profile.lastActivity">
          <v-btn
            v-if="getDateOfLastInvite(profile)"
            disabled
            :color="colors.hwayzBrandGold"
            :class="{'hide': !getDateOfLastInvite(profile)}"
            class="sent-button"
          >
            Invite sent
          </v-btn>
          <v-btn
            v-else
            :color="colors.hwayzBrandBlue"
            class="reinvite-button"
            :class="{'hide': getDateOfLastInvite(profile)}"
            @click="sendInviteToClient(profile)"
          >
            Resend invite
          </v-btn>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-title class="card-title">
        Property Specifics
        <span
          @click.stop="showClientDetailsModal=true"
        >UPDATE INFO</span>
      </v-card-title>
      <v-card-text class="details-container">
        <div>
          <span>Price Range:</span>
          <span>Goal Date:</span>
        </div>
        <div>
          <span>
            <template v-if="isShowPrice()">
              {{ formatPrice(profile.priceMin) }} - {{ formatPrice(profile.priceMax) }}
            </template>
          </span>
          <span>
            <template v-if="profile.goalDate">
              {{ formatDate(profile.goalDate) }}
            </template>
          </span>
        </div>
      </v-card-text>
    </v-card>
    <default-modal
      :show-modal="showClientDetailsModal"
      :modal-title="'Update Information'"
      :width="'450px'"
      @close-modal="showClientDetailsModal = false"
    >
      <update-client-details
        @close-modal="showClientDetailsModal = false"
      />
    </default-modal>
  </v-flex>
</template>
<script>
import UpdateClientDetails from '../UpdateClientDetails'
import DefaultModal from '../../modals/DefaultModal'
import { mapState, mapMutations } from 'vuex'
import currencyFormatter from 'currency-formatter'
import moment from 'moment'
import colors from '../../../scss/_colors.scss'
import { dateOfLastInvite, onSendInviteClicked } from '../../../services/invite-service'
export default {
  components: {
    UpdateClientDetails,
    DefaultModal
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors,
      showClientDetailsModal: false
    }
  },
  computed: {
    ...mapState('client', ['clientData']),
    ...mapState('agent', ['agentData'])
  },
  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    formatDate(date) {
      if (!date) return null
      return moment(date).format('MMMM, YYYY')
    },
    formatPrice(price) {
      return currencyFormatter.format(price, { code: 'USD' }).slice(0, -3)
    },
    async sendInviteToClient(client) {
      const updatedProfile = await onSendInviteClicked(client, this.agentData)
      this.setAgentData(updatedProfile)
    },
    getDateOfLastInvite(data) {
      return dateOfLastInvite(data)
    },
    isShowPrice() {
      if (typeof this.profile.priceMin !== 'number' || typeof this.profile.priceMax !== 'number') {
        return false
      }
      return true
    }
  }
}
</script>
<style lang="sass">
.client-details
  max-height: 500px
  display: flex
  flex-grow: 1
  align-items: stretch
  height: 100%
#clientDetails
  height: 100%
  width: 100%
.details-container
  display: flex
  flex-direction: column
  justify-content: space-around
  flex-wrap: wrap
.details-container div
  display: flex
  flex-direction: row
  justify-content: space-between
.details-container div:nth-child(1)
  font-weight: 450
  font-size: 1.2rem
  color: $hwayzBlack
.details-container div:nth-child(2)
  font-weight: 400
  font-size: 1.1rem
  padding-top: 16px
.client-details .card-title
  font-weight: 450
  font-size: 1.4rem
  padding: 16px 16px 8px
  display: flex
  justify-content: space-between
.card-title span
  color: $hwayzBrandGold
  font-size: 1.4rem
  cursor: pointer
.card-title span:hover
  color: $hwayzBrandBlue
.v-divider
  margin: 0 10px
.details-container .reinvite-button, .details-container .sent-button
  width: 50%
  height: 35px
  margin: 2rem auto 1rem
  font-size: 1.2rem
  border-radius: 4px
.reinvite-button .v-btn__content, .sent-button .v-btn__content
  color: $hwayzWhite !important
  text-transform: uppercase
  justify-content: center
.hide
  display: none

</style>
